module.exports = __webpack_public_path__ + "static/media/serverside-ai-logo-full.a26943dd.svg";